import { useBoard } from "src/pages/projects/board-context";
import { useGroups, useWorkflows } from "src/pages/projects/hooks";

/** The names describeEvent looks up, from the board's people, statuses, groups and tags. */
export function useEventContext() {
  const { memberById, currentUserId, tags } = useBoard();
  const { statusById } = useWorkflows();
  const { groups } = useGroups();
  return {
    statusName: (statusId: string) => statusById.get(statusId)?.name ?? null,
    userName: (userId: string) => memberById.get(userId)?.name ?? null,
    groupName: (userGroupId: string) =>
      groups.find((group) => group.id === userGroupId)?.name ?? null,
    tagName: (tagId: string) =>
      tags.find((tag) => tag.id === tagId)?.name ?? null,
    currentUserId,
  };
}
